import Choices from 'choices.js';

export default function () {
  const wpcf7 = window.document.querySelectorAll('.wpcf7');
  const selectClass = '.form__input--select';
  const searchableSelectClass = 'form__input--select-searchable';
  const selects = document.querySelectorAll(selectClass);
  const choices = [];

  selects.forEach((select) => {
    const isSearchable = select.classList.contains(searchableSelectClass);

    // eslint-disable-next-line no-new
    choices.push(new Choices(select, {
      searchEnabled: isSearchable,
      searchChoices: isSearchable,
      noResultsText: '',
    }));

    const dropdownContainer = select.closest('.choices');
    const isFocusedClass = 'is-focused';

    dropdownContainer.addEventListener('keydown', (event) => {
      const focusedItem = dropdownContainer.querySelector(`.${isFocusedClass}`);

      if (focusedItem) {
        focusedItem.classList.remove(isFocusedClass);
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const activeItem = dropdownContainer.querySelector('.is-highlighted');

        if (activeItem) {
          activeItem.classList.add(isFocusedClass);
        }
      }
    });
  });

  function validateCombobox(box) {
    const container = box.closest('.choices');
    container.classList.add('choices--invalid');

    if (box.value.length > 0) {
      container.classList.remove('choices--invalid');
    }
  }

  wpcf7.forEach((form) => {
    const s = form.querySelectorAll('.form__input--select.wpcf7-validates-as-required');
    const formEl = form.querySelector('.wpcf7-form');

    form.addEventListener('wpcf7invalid', () => {
      s.forEach((item) => {
        validateCombobox(item);
      });
    }, false);

    form.addEventListener('wpcf7submit', () => {
      choices.forEach((item) => {
        item.removeActiveItems();
      });
    }, false);

    s.forEach((item) => {
      item.addEventListener('change', () => {
        validateCombobox(item);
      });
    });

    /* https://github.com/Choices-js/Choices/issues/1053#issuecomment-1810488521 */
    formEl.addEventListener('reset', () => {
      choices.forEach((item) => {
        item.destroy();
        item.init();
      });
    });
  });
}
